module.exports = __webpack_public_path__ + "static/matthew-5db410d8cba7ff1db6a6662d783711aa.jpg";